var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import React from 'react';
import styled from 'styled-components';
var EmblemList = function () {
    return (React.createElement(Style, null,
        React.createElement("ul", null,
            React.createElement("li", null,
                React.createElement("em", { className: "emblem formula" }, "\uACF5\uC2DD\uB2F5\uBCC0"),
                "\uACF5\uC2DD\uB2F5\uBCC0"),
            React.createElement("li", null,
                React.createElement("em", { className: "emblem buyer" }, "\uAD6C\uB9E4"),
                "\uC0C1\uD488 \uAD6C\uB9E4\uD68C\uC6D0"),
            React.createElement("li", null,
                React.createElement("em", { className: "emblem guest" }, "\uBE44\uAD6C\uB9E4"),
                "\uC0C1\uD488 \uBE44\uAD6C\uB9E4\uD68C\uC6D0"),
            React.createElement("li", null,
                React.createElement("em", { className: "emblem minishop" }, "\uBBF8\uB2C8\uC0F5"),
                "\uC0C1\uD488 \uD310\uB9E4\uC790"),
            React.createElement("li", null,
                React.createElement("em", { className: "emblem hangshow" }, "\uD589\uC1FC"),
                "\uD589\uBCF5\uC1FC\uD551"))));
};
var Style = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    margin: 30px 0 0;\n    padding-bottom: 10px;\n    border-bottom: 1px solid #333;\n\n    ul {\n        display: flex;\n        justify-content: flex-end;\n    }\n    li {\n        margin-left: 10px;\n        color: #666;\n        line-height: 18px;\n        font-size: 12px;\n    }\n"], ["\n    margin: 30px 0 0;\n    padding-bottom: 10px;\n    border-bottom: 1px solid #333;\n\n    ul {\n        display: flex;\n        justify-content: flex-end;\n    }\n    li {\n        margin-left: 10px;\n        color: #666;\n        line-height: 18px;\n        font-size: 12px;\n    }\n"])));
export default EmblemList;
var templateObject_1;



//////////////////
// WEBPACK FOOTER
// ./src/detail/components/qna/emblem_list.tsx
// module id = 260
// module chunks = 0